import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {WinterHoardParsedGameData} from "../../server/data/IWinterHoardServerData";
import {WinterHoardGameModuleConfig} from "../../WinterHoardGameModuleConfig";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {TimelineLite} from "gsap";


export class FreespinSymbolDataStopped implements GameRoundPresentation {


    private _level:number = 0;
    private _multiplierString:string = "";
    private _symbolMultipliers:{M1:number, M2:number, M3:number, M4:number, M5:number};
    private _symbolsToM1:string [];
    private _currentMode:string;
    private _collectedAfter:number;
    private _collectedBefore:number;

    constructor(){
    }


    // TODO: MIGHT NEED TO CONSIDER FREESPIN_PICK MODE
    // TODO: MAJOR RACE CONDITION
    public prepare(data:WinterHoardParsedGameData):void { // TODO: add data:any?
        this._currentMode = data.mode;
        this._symbolMultipliers = data.symbolMultipliers;
        this._symbolsToM1 = data.symbolsToM1;
        this._collectedAfter = data.energyCollectedAfter;
        this._collectedBefore = data.energyCollectedBefore;

        this._level = this.determineFreespinLevel();

        //console.log("FS LEVEL: " + this._level);
        this.updateSymbolData();
    }

    private updateSymbolData():void {
        WinterHoardGameModuleConfig.symbolData.currentMode = this._currentMode;
        WinterHoardGameModuleConfig.symbolData.symbolMultipliers = this._symbolMultipliers;
        WinterHoardGameModuleConfig.symbolData.symbolsToM1 = this._symbolsToM1;
        WinterHoardGameModuleConfig.symbolData.level = this._level;
        WinterHoardGameModuleConfig.symbolDataStopped.collectedAfter = this._collectedAfter;
        WinterHoardGameModuleConfig.symbolDataStopped.collectedBefore = this._collectedBefore;
    }

    private determineFreespinLevel():number {
        let nr:number = 1;


        // TODO: break out to fs_multiplier specific case
        if(this._currentMode === "FREESPIN_MULTIPLIER" || this._currentMode === "FREESPIN_COMBINED" && this._symbolMultipliers) {
            for (let i = 0; i < 5; i++) {
                switch (i) {
                    case 0:
                        if (this._symbolMultipliers.M1 > 1) {
                            nr++;
                        }
                        break;

                    case 2:
                        if (this._symbolMultipliers.M2 > 1) {
                            nr++;
                        }
                        break;
                    case 3:
                        if (this._symbolMultipliers.M3 > 1) {
                            nr++;
                        }
                        break;
                    case 4:
                        if (this._symbolMultipliers.M4 > 1) {
                            nr++;
                        }
                        break;
                    case 5:
                        if (this._symbolMultipliers.M5 > 1) {
                            nr++;
                        }
                        break;
                }
            }
        }

        if(this._currentMode === "FREESPIN_TRANSFORM") {
            if(this._symbolsToM1) {
                nr = this._symbolsToM1.length;
            }
            //console.log("FS_TRANSFORMED LEVEL: " + this._level);
        }

        //console.log("FS_MULTIPLIER LEVEL: " + this._level);
        return nr;
    }

    public getAnimation(data: ParsedServerData) {
        const tl:TimelineLite = new TimelineLite();

        return tl;
    }
}